<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">题库管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="题库名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="权限类型">
          <el-select v-model="formInline.roles_type" clearable placeholder="请选择" style="width:150px;">
            <el-option v-for="item in $store.state.rolesType" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增题库</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="题库名称" min-width="200">
        </custom-table-column>
        <custom-table-column prop="question_count" label="题目数" width="100">
        </custom-table-column>
        <custom-table-column prop="" label="权限类型" width="100">
          <template slot-scope="scope">
            <span>{{ rolesLabel(scope.row.roles_type) }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="" label="组织结构" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 ? '-' + scope.row.structure_2 : '' }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="create_name" label="创建人" width="100">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="170">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleQuestionManage(scope.row)" type="text" size="small">题目管理</el-button>
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="606px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :disabled="type == 'view'" label-width="120px"
        class="demo-ruleForm">
        <el-form-item label="题库名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入" style="width:412px;"></el-input>
        </el-form-item>
        <el-form-item label="权限类型" prop="roles_type">
          <el-select v-model="ruleForm.roles_type" clearable placeholder="请选择" style="width:412px;">
            <el-option v-for="item in $store.state.rolesType" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属组织结构" prop="structure_1">
          <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell"
            @handleOrganQuery="handleOrganQueryNew({ limit: false, dep: 'structure_1', major: 'structure_2' })">
          </OrganDialog>
          <el-input v-model="selectName" placeholder="请选择" style="width:412px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;" v-if="type != 'view'">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 题目管理弹窗:内嵌题目管理子组件,传入当前题库 id -->
    <el-dialog :close-on-click-modal="false" title="题库题目管理" :visible.sync="bankDialogVisible" width="1150px" top="5vh">
      <question-item-manage v-if="bankDialogVisible" :key="currentBankId" :collection-id="currentBankId">
      </question-item-manage>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import QuestionItemManage from './questionItemManage.vue';

export default {
  name: 'questionBank',
  mixins: [mixinList, mixinOrgan],
  components: {
    QuestionItemManage,
  },
  data() {
    return {
      formInline: {
        name: '',
        roles_type: '',
        structure_1: '',
        structure_2: '',
      },
      levell: [1, 2],
      selectName: '',
      organLabel: '',
      bankDialogVisible: false,
      currentBankId: '',
      ruleForm: {
        name: '',
        roles_type: '',
        structure_1: '',
        structure_2: '',
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        roles_type: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    };
  },
  methods: {
    rolesLabel(val) {
      const item = this.$store.state.rolesType.find(i => i.value == val)
      return item ? item.label : val
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ dep: 'structure_1', major: 'structure_2', formK: 'formInline' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_course/collection/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    // 打开题目管理弹窗:传入当前题库 id(key 重建子组件以刷新该题库题目)
    handleQuestionManage(row) {
      this.currentBankId = row.id
      this.bankDialogVisible = true
    },
    // 编辑/详情回填:组织文本回显
    handleEditInit(row) {
      this.handleEditCallBackSetStruc({ dep: 'structure_1', major: 'structure_2', row })
    },
    detailMethod(row) {
      this.handleEditNew(row, ['id'], () => this.handleEditInit(row))
      this.type = 'view'
      this.title = '详情'
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/new_course/collection/insert', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/new_course/collection/update', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_course/collection/destroy/${this.delid}`, 'DELETE');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
